import Swiper from 'swiper/bundle';

export default () => {
  const section = document.querySelector('.js-come-ti-senti');
  const custom_cursor = document.querySelector('.js-custom-cursor');

  if (section && custom_cursor) {
    document.addEventListener('pointermove', e => {
      custom_cursor.style.top = (e.pageY - 64 ) + 'px'; 
      custom_cursor.style.left = (e.pageX - 64 ) + 'px';
      if (e.target.className === 'Cta SlideFeel__Cta') {
        custom_cursor.classList.add('is-on-card');
      } else {
        custom_cursor.classList.remove('is-on-card');
      }

    })
    section.addEventListener('mouseover', () => {
      custom_cursor.classList.add('is-visible');
    })
    section.addEventListener('mouseleave', () => {
      custom_cursor.classList.remove('is-visible');
    })
  }

  const feel_slider = document.querySelector('.js-come-ti-senti-swiper');
  if (feel_slider) {
    new Swiper(feel_slider, {
      slidesPerView: 1,
      effect: 'fade',
      loop: false,
      speed: 1000,
      fadeEffect: {
        crossFade: false,
      },
      longSwipesMs: 1000,
      on: {
        sliderFirstMove: function (swiper, event) {
          if (event.movementX >= 1) {
            custom_cursor.classList.add('is-dragging-right')
            custom_cursor.classList.remove('is-dragging-left')
          }
          if (event.movementX <= -1) {
            custom_cursor.classList.add('is-dragging-left')
            custom_cursor.classList.remove('is-dragging-right')
          }
        },
      },
    });
  }
}